import { EditContactForm } from "@/components/EditContactForm/EditContactForm";
import { NotesWriter } from "@/components/NotesWriter/NotesWriter";
import { LayoutWorkstationHeader } from "@/components/_layouts/LayoutWorkstationHeader/LayoutWorkstationHeader";
import { LayoutWorkstationSidebar } from "@/components/_layouts/LayoutWorkstationSidebar/LayoutWorkstationSidebar";
import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { ContactRecord, getCurrentContactEntity } from "@/models/contact";
import { PartialEntityRecord } from "@/orm/types";
import { ScrollArea, Stack } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { useAsync } from "react-async-hook";
import { Header } from "./Header";

export const Main = () => {
  const entity = getCurrentContactEntity();
  const { inactiveElementProps } = useIsPlanInactive();

  const viewPortSize = useViewportSize();

  return (
    <LayoutWorkstationHeader header={<Header />}>
      <LayoutWorkstationSidebar
        align="right"
        sidebar={<NotesWriter entity={entity} />}
        size={viewPortSize.width < 1375 ? "md" : "xl"}
        {...inactiveElementProps}
      >
        <ScrollArea w={"100%"} h={"100%"} style={{ overflow: "auto" }}>
          <EditContact />
        </ScrollArea>
      </LayoutWorkstationSidebar>{" "}
    </LayoutWorkstationHeader>
  );
};

const EditContact = () => {
  const entity = getCurrentContactEntity();
  const { result: contact } = useAsync(entity.hydrate, []);

  const onValuesChange = (values: PartialEntityRecord<ContactRecord>) => {
    //remove notes from values
    delete values.notes;
    entity.update(values);
  };

  if (!contact) return null;

  return (
    <Stack p="sm">
      <EditContactForm
        initialValues={contact}
        onValuesChange={onValuesChange}
      />
    </Stack>
  );
};
